import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ExportIcon } from '@work4all/assets/icons/export.svg';

import { Base } from '../base/Base';
import { BaseActionProps } from '../types';

export const Export: React.FC<BaseActionProps> = (props) => {
  const { t } = useTranslation();

  return <Base title={t('MASK.EXPORT')} icon={<ExportIcon />} {...props} />;
};
